// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_product_category_code: yup.string().label("Category code").required(),
  mr_product_category_name: yup.string().label("Category name").required()
})